import { toStatusType } from 'App/rtk';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { useGetPendingChargesQuery } from 'domains/Billing/Checkout/CheckoutApi';

function usePendingCharges(initialFetch = true) {
  const { status, refetch, data } = useGetPendingChargesQuery(undefined, {
    skip: !initialFetch,
  });

  const planPending = data?.rawCharges.some(
    (charge) => charge.conceptCode === 'plan-cost',
  );

  return {
    ...convertStatusTypeToObject(status),
    status: toStatusType(status),
    charges: data?.rawCharges,
    groupedCharges: data?.groupedCharges,
    storeUpToDate: data?.rawCharges?.length === 0,
    planPending,
    refreshPendingCharges: refetch,
  };
}

export { usePendingCharges };
